import $ from "jquery";
import state from "./state";

import blockJSON from "../block.json";
import { getScrollVars } from "./scroll";

export function getSlidesContainer(slider) {
  return $(slider).find(".dynamic-slides-container");
}
export function getSlidesRecipient(slider) {
  return $(slider).find(".dynamic-slides");
}
export function getCloserSlider(element) {
  return $(element).closest(".ae-block-dynamic-slider");
}
export function getSlides(slider) {
  return getSlidesRecipient(slider).find(".dynamic-slide");
}

export function getControlEls(slider) {
  return {
    controlLeft: $(slider).find(".slider-control-prev"),
    controlRight: $(slider).find(".slider-control-next"),
  };
}

export function getFirstSlide(slider) {
  return getSlidesRecipient(slider).find(".dynamic-slide:first-child");
}

export function getLastSlide(slider) {
  return getSlidesRecipient(slider).find(".dynamic-slide:last-child");
}

export function shouldWait(slider) {
  const isMoving = $(slider).hasClass("moving");
  const isLoading =
    $(slider).hasClass("prev-loading") || $(slider).hasClass("next-loading");
  return isMoving || isLoading;
}

export function setSlidesWidthAndHeight(sliderId) {
  const slider = $("#" + sliderId);
  const slides = getSlides(slider);
  const outnumber = 10000;
  $(slides).height(outnumber);
  const { slidesWidth } = getScrollVars(slider);
  const imgsHeight = getMinMaxImgsHeight(slider);
  const squaredSize = Math.min(slidesWidth, imgsHeight);

  $(slider).find('div[class*="slider-control"]').height(squaredSize);
  $(slider).find("div.dynamic-slides-container").height(squaredSize);

  $(slides).height(squaredSize);
  $(slides).find("img").css("height", squaredSize);
  if (window.innerWidth < 480) {
    $(slides).width(slidesWidth);
    $(slides).find("img").css("width", slidesWidth);
  }

  console.log(state.getState(sliderId));
  const displayLayout = state.get(sliderId, "displayLayout");
  if (displayLayout && displayLayout.showBelow) {
    setTextBelow(sliderId);
  }
}

export function setTextBelow(sliderId) {
  const slider = $("#" + sliderId);
  const slides = getSlides(slider);
  const slidesContainer = getSlidesContainer(slider);
  let max = 0;

  for (const slide of slides) {
    slide.classList.add("with-text-below");

    const text = slide.querySelector(".overlay-button-text");
    if (text) {
      text.classList.add("show-below");
      text.style.top = "initial";
      text.style.bottom = "initial";

      const textHeight = text.getBoundingClientRect().height;
      if (textHeight > max) {
        max = textHeight;
      }
      text.style.height = "auto";
    }
  }
  const imgsHeight = getMinMaxImgsHeight(slider);
  $(slides).find(".img-container").height(imgsHeight);
  $(slider).find('div[class*="slider-control"]').height(imgsHeight);

  $(slidesContainer).height(imgsHeight + max);
  $(slides).height(imgsHeight + max);
  $(slider).height(imgsHeight + max);
}

export function getMinMaxImgsHeight(slider) {
  const slides = getSlides(slider);
  const heights = []; //create empty array to store height values
  let tallest; //create variable to make note of the tallest slide

  if (slides.length) {
    slides.each(function () {
      //add heights to array
      heights.push($(this).height());
    });
    tallest = Math.max.apply(null, heights); //save largest value
    if (tallest < 125) {
      tallest = 150;
    }
    if (tallest < 150) {
      tallest = 175;
    }
    if (tallest > 300) {
      tallest = 300;
    }
    return tallest;
  }
}

export function getBlockDataById(id) {
  const sliderDataSelector = `#data-slider-${id}`;

  const dataEl = $(sliderDataSelector);
  let sliderData;
  try {
    sliderData = JSON.parse(dataEl.text());
  } catch (error) {
    sliderData = dataEl.text();
  }

  const DEFAULT_ATTS = getDefaultBlockAtts(blockJSON.attributes);

  const data = sliderData ? sliderData : DEFAULT_ATTS;

  console.log("data", sliderData, data);
  if (!isGutenbergActive()) dataEl.remove();

  return data;
}

export function shouldRepeat(slider, force) {
  updateQueriedIds(slider);

  const hasRepeatClass = $(slider).hasClass("repeat");
  if (force && !hasRepeatClass) $(slider).addClass("repeat");
  if (hasRepeatClass) return true;

  const sliderId = $(slider).attr("id");

  if (
    state.get(sliderId, "queriedIds").length >=
    state.get(sliderId, "query").found_posts
  ) {
    $(slider).addClass("repeat");

    return true;
  }

  return false;
}

export function updateQueriedIds(slider) {
  const sliderId = $(slider).attr("id");
  const qIds = state.get(sliderId, "queriedIds").map((q) => parseInt(q));
  const sIds = [];
  const slides = getSlides(slider);
  slides.each(function () {
    return sIds.push(parseInt(this.id));
  });

  // Compare array function
  // Ref: https://www.freecodecamp.org/news/how-to-compare-arrays-in-javascript/
  const compareArrs = (s1, s2) =>
    s1.length === s2.length &&
    s1.every((element, index) => element === s2[index]);

  const equal = compareArrs(qIds, sIds);
  if (!equal) {
    state.set(sliderId, "queriedIds", sIds);
  }
}

export function getPPP(sliderId) {
  const statePPP = state.get(sliderId, "displayLayout")?.slidesPerPag || 4;

  const classes = $(`#${sliderId}`).attr("class");
  if (!classes) return statePPP;
  const perPageCls = classes
    .split(" ")
    .filter((c) => /^[^\d]*(\d+)-per-page/.test(c));
  const perPage = perPageCls.length ? perPageCls[0][0] : statePPP;
  const displayLayout = state.get(sliderId, "displayLayout");

  state.set(sliderId, "displayLayout", {
    ...displayLayout,
    slidesPerPage: parseInt(perPage),
  });

  return parseInt(perPage);
}

export function updateLoadedSlides(slider) {
  const slides = getSlides(slider);
  const sliderId = $(slider).attr("id");
  const slidesIds = [];
  $(slides).each(function () {
    slidesIds.push($(this).attr("id"));
  });

  state.set(sliderId, "queriedIds", slidesIds);
}

export function isGutenbergActive() {
  return document.body.classList.contains("block-editor-page");
}

/**
 * Returns an object representing the default values for a block's attributes.
 *
 * @param {string} name       The name of the block.
 * @param {Object} attributes The block's attributes object.
 *
 * @return {Object}            An object with the default values for the block's attributes.
 */
export function getDefaultBlockAtts(attributes) {
  const defaults = {};

  Object.keys(attributes).forEach((key) => {
    defaults[key] = attributes[key].default;
  });

  return defaults;
}

import { select, subscribe } from "@wordpress/data";

export function whenEditorIsReady() {
  return new Promise((resolve) => {
    const unsubscribe = subscribe(() => {
      // This will trigger after the initial render blocking, before the window load event
      // This seems currently more reliable than using __unstableIsEditorReady
      if (
        select("core/editor").isCleanNewPost() ||
        select("core/block-editor").getBlockCount() > 0
      ) {
        unsubscribe();
        resolve();
      }
    });
  });
}
